import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    SHOPIFY_ADMIN_ACCESS_TOKEN: z.string().min(1),
    SHOPIFY_FLOW_BEARER_SECRET: z.string().min(1),
    KLAVIYO_PRIVATE_KEY: z.string().min(1),
    AMAZON_ACCESS_KEY: z.string().min(1),
    AMAZON_SECRET_KEY: z.string().min(1),
    REFERRALCANDY_SECRET_KEY: z.string().min(1),
    REFERRALCANDY_ACCESS_ID: z.string().min(1),
    HUBSPOT_PRIVATE_APP_TOKEN: z.string().min(1),
    FEDEX_API_KEY: z.string().min(1).optional(),
    FEDEX_SECRET_KEY: z.string().min(1).optional(),
    FEDEX_API_URL: z.string().url().default("https://apis.fedex.com"),
    OPENAI_CONVERSIONS_PIXEL_ID: z.string().min(1).optional(),
    OPENAI_CONVERSIONS_API_KEY: z.string().min(1).optional(),
    X_CONVERSIONS_PIXEL_ID: z.string().min(1).optional(),
    X_CONVERSIONS_EVENT_ID: z.string().min(1).optional(),
    X_CONVERSIONS_PIXEL_TOKEN: z.string().min(1).optional(),
    META_CONVERSIONS_ACCESS_TOKEN: z.string().min(1).optional(),
    META_CONVERSIONS_TEST_EVENT_CODE: z.string().min(1).optional(),
  },
  client: {
    NEXT_PUBLIC_WEB_ENVIRONMENT: z.enum(["test", "production"]).optional(),
  },
  runtimeEnv: {
    SHOPIFY_ADMIN_ACCESS_TOKEN: process.env["SHOPIFY_ADMIN_ACCESS_TOKEN"],
    SHOPIFY_FLOW_BEARER_SECRET: process.env["SHOPIFY_FLOW_BEARER_SECRET"],
    KLAVIYO_PRIVATE_KEY: process.env["KLAVIYO_PRIVATE_KEY"],
    AMAZON_ACCESS_KEY: process.env["AMAZON_ACCESS_KEY"],
    AMAZON_SECRET_KEY: process.env["AMAZON_SECRET_KEY"],
    REFERRALCANDY_SECRET_KEY: process.env["REFERRALCANDY_SECRET_KEY"],
    REFERRALCANDY_ACCESS_ID: process.env["REFERRALCANDY_ACCESS_ID"],
    HUBSPOT_PRIVATE_APP_TOKEN: process.env["HUBSPOT_PRIVATE_APP_TOKEN"],
    FEDEX_API_KEY: process.env["FEDEX_API_KEY"],
    FEDEX_SECRET_KEY: process.env["FEDEX_SECRET_KEY"],
    FEDEX_API_URL: process.env["FEDEX_API_URL"],
    OPENAI_CONVERSIONS_PIXEL_ID: process.env["OPENAI_CONVERSIONS_PIXEL_ID"],
    OPENAI_CONVERSIONS_API_KEY: process.env["OPENAI_CONVERSIONS_API_KEY"],
    X_CONVERSIONS_PIXEL_ID: process.env["X_CONVERSIONS_PIXEL_ID"],
    X_CONVERSIONS_EVENT_ID: process.env["X_CONVERSIONS_EVENT_ID"],
    X_CONVERSIONS_PIXEL_TOKEN: process.env["X_CONVERSIONS_PIXEL_TOKEN"],
    META_CONVERSIONS_ACCESS_TOKEN: process.env["META_CONVERSIONS_ACCESS_TOKEN"],
    META_CONVERSIONS_TEST_EVENT_CODE:
      process.env["META_CONVERSIONS_TEST_EVENT_CODE"],
    NEXT_PUBLIC_WEB_ENVIRONMENT: process.env["NEXT_PUBLIC_WEB_ENVIRONMENT"],
  },
  emptyStringAsUndefined: true,
  skipValidation: !!process.env["SKIP_ENV_VALIDATION"],
});
